import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import Wizard from '../Wizard'
import { getEditCampaignParams } from '../../../utils/payload-generator'
import { CampaignContext } from '../../../contexts/CampaignContext'
import { GoToListPage } from '../../shared/types/RoutingTypes'
import { LoaderDialog } from 'functional-foundations'
import { EnrollmentEventsContext } from '../../../contexts/EnrollmentEventsContext'

/**
 *
 */
const Show = ({ goToListPage }: GoToListPage) => {
    const [loading, setLoading] = useState(false)
    const { campaigns, editCampaign, campaignNetworkError, setCampaignNetworkError } = useContext(CampaignContext)

    let { id } = useParams()
    id = Number.parseInt(id)
    const item = campaigns.find((x) => x.csp_campaign_id === id)
    const { removeEventsForId } = React.useContext(EnrollmentEventsContext)

    const onSubmit = async (data) => {
        setLoading(true)
        try {
            const editParams = await getEditCampaignParams(data, item)
            await editCampaign(editParams)
            removeEventsForId(id)
            if (!campaignNetworkError) goToListPage?.()
        } catch (err) {
            setCampaignNetworkError('Something went wrong')
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    if (!item) {
        return 'Not found'
    }

    return <div>
        <Wizard
            item={item}
            mode='edit'
            onSubmit={onSubmit}
            goToListPage={goToListPage}
        />
        <LoaderDialog
            isOpen={loading}
            title={'Processing your payment...'}
            subtitle='Please wait!'
            data-testid='loader-dialog'
        />
    </div>
}

export default Show
